import { getCookie } from "./components/utils";

EntityModule.registerInitializer(function (node) {
  $.ajaxSetup({ headers: { "X-XSRF-Token": getCookie("XSRF-TOKEN") } });
});
